module.exports = __webpack_public_path__ + "static/media/better-job-fit-alex.4c3e2050.jpg";